<template>
  <div class="bg-pattern min-h-screen font-display text-primal">
    <slot />
  </div>
</template>

<style scoped>
.bg-pattern {
  background-color: #ededea;
  background-image: url('/patterns/onboarding.svg');
}
</style>
